"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var ArrowIndicatorUpOutline_1 = __importDefault(require("../icons/generated/ArrowIndicatorUpOutline"));
var ArrowIndicatorDownOutline_1 = __importDefault(require("../icons/generated/ArrowIndicatorDownOutline"));
exports.CollapsibleListElement = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  color: ", ";\n  background-color: ", ";\n  padding: 16px;\n  margin-bottom: 16px;\n"], ["\n  display: flex;\n  color: ", ";\n  background-color: ", ";\n  padding: 16px;\n  margin-bottom: 16px;\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colours.global.lightWhite;
}, function (_a) {
    var theme = _a.theme;
    return theme.colours.global.offBlack_10;
});
exports.CollapsibleListElement.displayName = 'CollapsibleListElement';
var Headline = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  font-size: 16px;\n  color: ", ";\n  font-weight: bold;\n  cursor: pointer;\n  margin-bottom: 16px;\n\n  svg {\n    width: 24px;\n    height: 24px;\n    fill: ", ";\n    margin-right: 8px;\n  }\n"], ["\n  display: flex;\n  align-items: center;\n  font-size: 16px;\n  color: ", ";\n  font-weight: bold;\n  cursor: pointer;\n  margin-bottom: 16px;\n\n  svg {\n    width: 24px;\n    height: 24px;\n    fill: ", ";\n    margin-right: 8px;\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colours.global.lightWhite;
}, function (_a) {
    var theme = _a.theme;
    return theme.colours.global.lightWhite;
});
Headline.displayName = 'Headline';
var Border = styled_components_1.default.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  flex-grow: 1;\n  margin-left: 12px;\n  border-top: 1px solid ", ";\n"], ["\n  flex-grow: 1;\n  margin-left: 12px;\n  border-top: 1px solid ", ";\n"])), function (_a) {
    var colours = _a.theme.colours;
    return colours.global.lightFadedWhite;
});
Border.displayName = 'Border';
var CollapsibleList = function (_a) {
    var title = _a.title, isOpen = _a.isOpen, children = _a.children, onClick = _a.onClick;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(Headline, { onClick: onClick },
            isOpen && react_1.default.createElement(ArrowIndicatorUpOutline_1.default, null),
            !isOpen && react_1.default.createElement(ArrowIndicatorDownOutline_1.default, null),
            react_1.default.createElement("span", null, title),
            react_1.default.createElement(Border, null)),
        isOpen && children));
};
CollapsibleList.displayName = 'CollapsibleList';
exports.ManagedCollapsibleList = function (props) {
    var _a = react_1.useState(true), isOpen = _a[0], setIsOpen = _a[1];
    return react_1.default.createElement(CollapsibleList, __assign({}, props, { isOpen: isOpen, onClick: function () { return setIsOpen(!isOpen); } }));
};
exports.ManagedCollapsibleList.displayName = 'ManagedCollapsibleList';
exports.default = CollapsibleList;
var templateObject_1, templateObject_2, templateObject_3;
